import { render, staticRenderFns } from "./UserPasswordTabAccount.vue?vue&type=template&id=554d3e28"
import script from "./UserPasswordTabAccount.vue?vue&type=script&lang=js"
export * from "./UserPasswordTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports